<template>
    <div>
        <table class="table table-bordered table-hover table-tree-view">
            <thead>
                <tr>
                    <th v-if="showLevelBadge" class="tree-level-column">&nbsp;</th>
                    <th class="tree-expand-column">&nbsp;</th>
                    <slot name="header"></slot>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(item, idx) in flattenedNodes"
                    :key="idx"
                    class="tree-node-row"
                    :class="'tree-node-level-' + item.level">
                    <td v-if="showLevelBadge" class="tree-level-cell" :class="'tree-level-bg-' + item.level">
                        <span v-if="item.level > 0">{{ item.level }}</span>
                    </td>
                    <td class="tree-expand-cell">
                        <span v-if="item.node.ListSons && item.node.ListSons.length > 0"
                              class="tree-toggle-btn"
                              @click="toggleNode(item.node)">
                            <i :class="item.node.IsExpand === 0 ? 'glyphicon glyphicon-chevron-down' : 'glyphicon glyphicon-chevron-right'"
                               class="tree-icon"></i>
                        </span>
                        <span v-else class="tree-no-children"></span>
                    </td>
                    <slot name="content" :node="item.node" :level="item.level"></slot>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>

    export default {
        name: 'YtTreeView',
        props: {
            params: {
                type: Object,
                default: function () {
                    return {};
                }
            },
            listNodes: {
                type: Array,
                default: function () {
                    return [];
                }
            },
            showLevelBadge: {
                type: Boolean,
                default: true
            }
        },
        model: {
            prop: 'listNodes',
            event: 'change'
        },
        computed: {
            flattenedNodes() {
                const result = [];
                const flatten = (nodes, level) => {
                    if (!nodes || !nodes.length) return;
                    nodes.forEach(node => {
                        result.push({ node, level });
                        // 如果节点展开（IsExpand === 0），则递归展开子节点
                        if (node.IsExpand === 0 && node.ListSons && node.ListSons.length > 0) {
                            flatten(node.ListSons, level + 1);
                        }
                    });
                };
                flatten(this.listNodes, 0);
                return result;
            }
        },
        methods: {
            toggleNode(node) {
                // 切换节点展开状态
                this.$set(node, 'IsExpand', node.IsExpand === 1 ? 0 : 1);
            }
        }
    }


</script>

<style scoped>
    table.table-tree-view td {
        text-align: center !important;
        vertical-align: middle !important;
    }

    table.table-tree-view th {
        text-align: center;
        background-color: #f5f7fa;
        color: #606266;
        vertical-align: middle !important;
        font-size: 14px;
        font-weight: 600;
        border-bottom: 1px solid #dfe6ec;
    }

        table.table-tree-view th.tree-expand-column {
            width: 40px;
            text-align: left !important;
        }

        table.table-tree-view th.tree-level-column {
            width: 40px;
        }

    /* 树形节点样式 */
    .tree-expand-cell {
        text-align: left !important;
        white-space: nowrap;
        padding-left: 8px !important;
    }

    .tree-level-cell {
        text-align: center !important;
        white-space: nowrap;
        font-weight: bold;
        color: white;
        font-size: 13px;
    }

    .tree-level-bg-0 {
        background-color: #337ab7 !important;
    }

    .tree-level-bg-1 {
        background-color: #5bc0de !important;
    }

    .tree-level-bg-2 {
        background-color: #5cb85c !important;
    }

    .tree-level-bg-3 {
        background-color: #f0ad4e !important;
    }

    .tree-level-bg-4 {
        background-color: #d9534f !important;
    }

    .tree-level-bg-5 {
        background-color: #9b59b6 !important;
    }

    .tree-toggle-btn {
        display: inline-block;
        cursor: pointer;
        padding: 2px 6px;
        margin-right: 4px;
        transition: all 0.2s ease;
        user-select: none;
    }

        .tree-toggle-btn:hover {
            background-color: #f0f0f0;
            border-radius: 2px;
        }

    .tree-icon {
        font-size: 11px;
        color: #666;
        transition: all 0.2s ease;
    }

    .tree-toggle-btn:hover .tree-icon {
        color: #333;
    }

    .tree-no-children {
        display: inline-block;
        width: 16px;
    }

    /* 不同层级的行样式 */
    .tree-node-level-0 {
        font-weight: normal; /* Remove bold default for level 0, let template handle it */
    }

    .tree-node-level-1 {
        background-color: #f9f9f9;
    }

    .tree-node-level-2 {
        background-color: #f5f5f5;
    }

    .tree-node-level-3 {
        background-color: #f0f0f0;
    }
</style>
